import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `POST /client/:cid/users/:id/hubs {hub_id}`. */
export const grantHubAccess = async (user_id: string, hub_id: string): Promise<any> => {
  await lpRequest('POST', clientPath(`/users/${user_id}/hubs`), { body: { hub_id } });

  return getUser(user_id);
};
